var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TemplateHeader',{attrs:{"header":'Riwayat Penjualan',"withBackButton":true,"to":("/dashboard/" + _vm.id),"branch_name":_vm.branch_name}},[_c('TableSold',{attrs:{"API":("/sold-product/" + _vm.id),"allData":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }